module.exports = __webpack_public_path__ + "3ec2265086335ee20733b847a3d7ca12.svg";